export default "__VITE_ASSET__222dc1b8__"